import { Alert, AlertDescription, type AlertProps } from "@chakra-ui/react";
import { Heading, Text } from "@equidefi/ui";
import type { FC, ReactNode } from "react";

interface HighlightCardProps extends AlertProps {
  text: string | ReactNode;
  title: string;
}

export const HighlightCard: FC<HighlightCardProps> = ({ title = "", text = "", ...rest }) => (
  <Alert
    status="info"
    borderRadius="lg"
    border="1px solid"
    backgroundColor="#F5EDFF"
    borderColor="#7147BD"
    boxShadow="sm"
    py={4}
    my={4}
    {...rest}>
    <AlertDescription alignItems="center" w="full" textAlign="center">
      <Heading textStyle="body" mb={2}>
        {title.toUpperCase()}
      </Heading>
      <Text mb={0} fontWeight="bold" textStyle="h1">
        {text}
      </Text>
    </AlertDescription>
  </Alert>
);
